import React from "react";
import "./styles/ButtonConnexion.css";

function ButtonConnexion() {
  return (
    <button type="submit" className="buttonconnexion">
      <h3>CONNEXION</h3>
    </button>
  );
}
export default ButtonConnexion;
